'use strict';

var IMAGE_WIDTHS = {
    PDP_SLIDER_IPHONE_X: 375,
    PDP_SLIDER_MOBILE_LOW_DENSITY: 480,
    PDP_SLIDER_MOBILE_HIGH_DENSITY: 960,
    PDP_SLIDER_DESKTOP_LOW_DENSITY: 535,
    PDP_SLIDER_DESKTOP_HIGH_DENSITY: 1070,
    PDP_SLIDER_DESKTOP_WIDE_SCREEN_LOW_DENSITY: 600,
    PDP_SLIDER_DESKTOP_WIDE_SCREEN_HIGH_DENSITY: 1200,
    PDP_SLIDER_DESKTOP_ULTRA_WIDE_SCREEN_LOW_DENSITY: 695,
    PDP_SLIDER_DESKTOP_ULTRA_WIDE_SCREEN_HIGH_DENSITY: 1390,
    PDP_THUMBNAIL_LOW_DENSITY: 104,
    PDP_THUMBNAIL_HIGH_DENSITY: 208,
    PDP_ZOOM: 1500,
    PDP_ZOOM_XL: 2500,
    PLP_DESKTOP_TABLET_LOW_DENSITY: 375,
    PLP_DESKTOP_TABLET_HIGH_DENSITY: 750,
    PLP_DESKTOP_WIDE_SCREEN_LOW_DENSITY: 465,
    PLP_DESKTOP_WIDE_SCREEN_HIGH_DENSITY: 930,
    PLP_MOBILE_LOW_DENSITY: 228,
    PLP_MOBILE_HIGH_DENSITY: 456,
    PLP_IPHONE_X: 375,
    PLP_HERO_IPHONE_X: 355,
    PLP_HERO_MOBILE_LOW_DENSITY: 460,
    PLP_HERO_MOBILE_HIGH_DENSITY: 920,
    REVIEWS_LOW_DENSITY: 72,
    REVIEWS_HIGH_DENSITY: 144,
    INFUSION_MOBILE_LOW_DENSITY: 177,
    INFUSION_MOBILE_HIGH_DENSITY: 354,
    INFUSION_DESKTOP_TABLET_LOW_DENSITY: 354,
    INFUSION_DESKTOP_TABLET_HIGH_DENSITY: 708,
    THUMBNAIL_LOW_DENSITY: 72,
    THUMBNAIL_HIGH_DENSITY: 144,
    PROMO_CARD_LOW_DENSITY: 58,
    PROMO_CARD_HIGH_DENSITY: 116,
    PROMO_CARD_SPOTLIGHT_LOW_DENSITY: 85,
    PROMO_CARD_SPOTLIGHT_HIGH_DENSITY: 170,
    COLOR_VARIANTS: 136,
    CART_IMAGE: 160,
    RATINGS_OVERLAY_IMAGE: 248,
};

exports.IMAGE_WIDTHS = IMAGE_WIDTHS;
//# sourceMappingURL=imageWidths-0e171afa.js.map
